module.exports = __webpack_public_path__ + "media/images/xpass/deal-featured-41e90478c0bae3b507c77c0c33b70e06.svg";